module.exports = __webpack_public_path__ + "img/jinxingzhong.5a984d02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/process/jinxingzhong.png
// module id = 512
// module chunks = 137